module.exports = __webpack_public_path__ + "static/device_watch_android_dark-2868a1baaaa5643618e934bf096ac4ea.png";